import { DynamicFeed } from "@mui/icons-material";
import React, { memo } from "react";

import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();

  return (
    <NodeCard color="#683AC8" icon={<DynamicFeed />} title="Menu" id={id}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <div className={classes.clamp3}>{data.message}</div>
      {data.arrayOption.map((option) => (
        // a saída de cada opção fica presa à própria linha (não depende da altura do texto)
        <div className={classes.outRow} key={option.number}>
          <span>{`[${option.number}] ${option.value}`}</span>
          <NodeHandle
            type="source"
            id={"a" + option.number}
            top="50%"
            offset={-21}
            isConnectable={isConnectable}
          />
        </div>
      ))}
    </NodeCard>
  );
});
